import React, { createContext, useContext, useState } from "react";

// Define the shape of your context
interface TwoWayAuthContextProps {
    isTwoWayAuthenticated: boolean;
    setIsTwoWayAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create the context with a default value (this will be overridden by the provider)
const TwoWayAuthContext = createContext<TwoWayAuthContextProps | undefined>(undefined);

// Provider component
export const TwoWayAuthProvider: React.FC = ({ children }) => {
    const [isTwoWayAuthenticated, setIsTwoWayAuthenticated] = useState(true);

    return (
        <TwoWayAuthContext.Provider value={{ isTwoWayAuthenticated, setIsTwoWayAuthenticated }}>
            {children}
        </TwoWayAuthContext.Provider>
    );
};

// Custom hook for consuming the context
export const useTwoWayAuthContext = () => {
    const context = useContext(TwoWayAuthContext);
    if (!context) {
        throw new Error("useTwoWayAuthContext must be used within a TwoWayAuthProvider");
    }
    return context;
};
